export default __webpack_public_path__ + "static/media/expoindo-6.7d22002a.jpg";